export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70356c26ea2557f3ac2f511ad9b27df0630024267c&name=pushAdClickData!'